<template>
  <div v-loading="loading">
    <el-divider>积分抽奖</el-divider>
    <el-tag
      v-for="item in items"
      :key="item.lotteryId"
      size="medium"
      type="success"
      effect="plain"
      @click="selectitem(item)">
      {{ item.lotteryName }}
    </el-tag>

    <el-divider>报名抽奖</el-divider>
    <el-tag
      v-for="item in items1"
      :key="item.lotteryId"
      size="medium"
      type="success"
      effect="plain"
      @click="selectitem(item)">
      {{ item.lotteryName }}
    </el-tag>
  </div>
</template>

<script>
export default {
  name: 'IntegralTask',
  props: {
    linkType: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      loading: false,
      items: [],
      items1: []
    }
  },
  mounted() {
    this.fetchList()
    this.fetchList1()
  },
  methods: {
    selectitem(item) {
      this.$emit('select', {
        linkType: this.linkType,
        link: item.lotteryId,
        title: item.lotteryName,
        contentType: item.lotteryType
      })
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('lottery/getlotterys', {
        payload: {
          pageNum: 1,
          pageSize: 10000,
          status: 1,
          lotteryType: 1
        },
        success: res => {
          this.loading = false
          this.items = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetchList1() {
      this.loading = true
      this.$store.dispatch('lottery/getlotterys', {
        payload: {
          pageNum: 1,
          pageSize: 10000,
          status: 1,
          lotteryType: 8
        },
        success: res => {
          this.loading = false
          this.items1 = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style>

</style>
